<template>
  <base-dialog
    :action="onAction"
    :action-name="actionName"
    :close="onClose"
    :title="title"
  >
    <template #activator="{ on }">
      <slot name="activator" v-bind="{ on }" />
    </template>

    <template #content>
      <div>
        <p>
          <slot name="options" />
          <br>
          <strong>{{ message }}</strong>
        </p>
      </div>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from "../Common/BaseDialog";

export default {
  components: { BaseDialog },
  props: {
    title: { type: String, default: '' },
    actionName: { type: String, default: 'Create' },
    message: { type: String, default: '' },
    okButton: { type: String, default: 'Ok' },
    cancelButton: { type: String, default: 'Cancel' },
    showOkButton: { type: Boolean, default: true },
    showCancelButton: { type: Boolean, default: true },
    id: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      name: "",
    };
  },
  methods: {
    onClose() {
      this.$emit("close");
    },
    async onAction() {
      const payload = {
        id: this.id,
      };
      this.$emit("action", payload);
    },
  },
};
</script>
